import React, { useState } from "react";
import { Box, Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import renderHTML from "react-render-html";
import "react-toastify/dist/ReactToastify.css";
import { reusableFn } from "../../components/reusableComponents/reusableFn";
import {
  DAMAGE_REMARK,
  LABEL_COPAYMENT,
  LABEL_ESTIMATED_BY,
  LABEL_IMEI_NUMBER,
  LABEL_JOB_SHEET_NUMBER,
  LABEL_PRODUCT,
  LABEL_UTR_NUMBER,
  LABEL_PARTIAL_PAYMENT,
  SERVICE_CENTRE_NAME,
} from "../../constants/";
import { useStyles } from "./styles";

function AdditionalDetails({ classes: { question }, item }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const renderText = (label, text, dataTip) => {
    return renderHTML(
      `<Box className=${question} >${label}: </Box> ${text}<br>`
    );
  };

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const renderDamageDetails = () => {
    const damageDetails = item?.data?.inputs?.damage_details;
    if (!damageDetails) return null;

    if (damageDetails.length > 50) {
      return (
        <>
          {isExpanded
            ? renderText(DAMAGE_REMARK, damageDetails)
            : renderText(DAMAGE_REMARK, `${damageDetails.slice(0, 50)} ...`)}
          <b onClick={handleToggleExpand}>
            {" "}
            &nbsp;
            {isExpanded ? "See less" : "See more"}
          </b>
        </>
      );
    }

    return renderText(DAMAGE_REMARK, damageDetails);
  };

  return (
    <Box>
      {item?.service_centre_name &&
        renderText(SERVICE_CENTRE_NAME, item?.service_centre_name)}
      {/* <br /> */}
      {item?.copayment_amount > 0 && (
        <>
          {renderHTML(
            `<Box className=${question}>${LABEL_COPAYMENT}: </Box> ₹${Number(
              item?.copayment_amount
            ).toLocaleString("en")}<br>`
          )}{" "}
          {/* <br /> */}
        </>
      )}
      {item?.product && renderText(LABEL_PRODUCT, item?.product)}
      {/* <br /> */}
      {item?.imei_number && renderText(LABEL_IMEI_NUMBER, item?.imei_number)}
      {/* <br /> */}
      {renderDamageDetails()}
      {/* <br /> */}
      {item?.estimated_by_name &&
        renderText(LABEL_ESTIMATED_BY, item?.estimated_by_name)}
      {/* <br /> */}
      {item?.data?.inputs?.job_sheet_number &&
        renderText(
          LABEL_JOB_SHEET_NUMBER,
          item?.data?.inputs?.job_sheet_number
        )}
      {/* <br /> */}
      {item?.utr_number && renderText(LABEL_UTR_NUMBER, item?.utr_number)}
      {/* <br /> */}
      {item?.repair_amount &&
        renderHTML(
          `<Box className=${question} style="color: ${
            item?.payment_successful ? "green" : "red"
          };">${LABEL_PARTIAL_PAYMENT}: </Box> <span style="color: ${
            item?.payment_successful ? "green" : "red"
          };">₹${Number(item?.repair_amount).toLocaleString("en")}</span><br>`
        )}
      {/* <br /> */}
      <br />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(AdditionalDetails);
